export enum ThemeItemEnum {
  backgroundImage = 1,
  header = 2,
  headerTopBorder = 3,
  sectionHeader = 4,
  progressBar = 5,
  startButton = 6,
  restartButton = 7,
  nextButton = 8,
  backButton = 9,
  newSurveyButton = 10,
  radioButton = 11,
  gradientStart = 12,
  gradientEnd = 13,
  scaleTrackColour = 14,
  scaleTrackSelectedColour = 15,
}
